import { render } from "./RecaptchaComponent.vue?vue&type=template&id=3dd6edc2&lang=pug"
import script from "./RecaptchaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RecaptchaComponent.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__